import React from 'react'
import { NavLink } from 'react-router-dom'
import { SlHome } from 'react-icons/sl'
import { RiGift2Line } from 'react-icons/ri'
import { IoGameControllerOutline } from 'react-icons/io5'
import { FiUser, FiUsers } from 'react-icons/fi'

const BottonMenu = () => {
  return (
    <div className='main_bottom_menus'>
      <nav className='bottom_link_main'>
        <NavLink exact to='/landing' className='bottom_link' activeClassName='active_link'>
          <div className='menuIconBadge'>
            <SlHome className='sidebar_link_icon' />
          </div>
          <span>Home</span>
        </NavLink>

        <NavLink exact to='/refer' className='bottom_link' activeClassName='active_link'>
          <div className='menuIconBadge'>
            <RiGift2Line className='sidebar_link_icon' />
          </div>
          <span>Rewards</span>
        </NavLink>

        <NavLink exact to='/landing' className='bottom_link' activeClassName='active_link'>
          <div className='menuIconBadge'>
            <IoGameControllerOutline className='sidebar_link_icon' />
          </div>
          <span>Game</span>
        </NavLink>

        <NavLink exact to='/support' className='bottom_link' activeClassName='active_link'>
          <div className='menuIconBadge'>
            <FiUsers className='sidebar_link_icon' />
          </div>
          <span>Friends</span>
        </NavLink>

        <NavLink exact to='/Profile' className='bottom_link' activeClassName='active_link'>
          <div className='menuIconBadge'>
            <FiUser className='sidebar_link_icon' />
          </div>
          <span>Profile</span>
        </NavLink>
      </nav>
    </div>
  )
}

export default BottonMenu
